import script from "./AppointmentDataPetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentDataPetRecordTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentDataPetRecordTableRow.vue?vue&type=style&index=0&id=15d6e2ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d6e2ad"]])

export default __exports__